import { render, staticRenderFns } from "./CourseTakePage.vue?vue&type=template&id=5c379ad1&"
import script from "./CourseTakePage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseTakePage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports